import React from 'react'
import Navbar from '../../components/Navbar'
import { Table,TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Box, Typography, Button, Grid  } from '@mui/material'; 
import { Link } from 'react-router-dom';
import Footer from '../../components/Footer'
import AspectRatio from '@mui/joy/AspectRatio';

function createData(name, link, ) {
    return { name, link,  };
  }
  
  const row1 = [
    //E-JOURNALS
    createData("Elsevier (Science Direct)", "https://www.sciencedirect.com/"),
    createData("IEEE ASPP & POP ALL", "https://ieeexplore.ieee.org/Xplore/home.jsp"),
    createData("Springer Nature", "https://link.springer.com/"),
    createData("Emerald", "https://www.emerald.com/insight/"),
    createData("EBSCO (Engineering Suite database)", "https://search.ebscohost.com/")
  ]
    const row2=[
    //E-BOOKS
    createData("Elsevier (Science Direct)", "https://www.sciencedirect.com/"),
    createData("Springer Nature", "https://link.springer.com/"),
    createData("EBSCO (Engineering Suite database)", "https://search.ebscohost.com/"),
    createData("Eduport Global -CBS  ", "https://www.eduport-global.com"),
    createData("BSP E-Books  ", "https://ebookstore.bspublications.net/library"),
    createData("Cengage Learning ", "https://cengageindiaelibrary.ipublishcentral.net/explore"),
    createData("Cambridge University Press ", "https://www.cambridge.org/core"),
    createData("Mint Books ", "https://hkbkce.mintbook.in"),
    createData("Quiklrn", "https://quiklrn.com/app.php"),


    
    
    ]
    const row3=[
    //RESOURCE SEARCH PLATFORM
    createData("KNIMBUS – Remote Access ", "https://hkbkitb.knimbus.com/user#/home"),
    createData("KNIMBUS – mLibrary App", "https://play.google.com/store/search?q=mlibrary&c=apps&hl=en"),
    createData("Drillbit – Plagiarism Detection Software", "https://www.drillbitplagiarismcheck.com/auth/login"),
  
  
  ]

export default function EResources() {
  return (
    <div>
        <Box top={0} position={'sticky'}><Navbar/></Box>
        {/************ * Heading ************************/}
        <Box overflow={'hidden'} sx={{ zIndex:'-12', position: 'relative',  height: '50vh', }}>
        <img
            src={'/imgs/Bg1.jpg'}
            alt="Background"
            style={{
            objectFit:'cover',
            width: '100%',
            height: '100%',
            }}
        />
        
            <Typography variant='h3'   color={'#fff'}  sx={{py:2, backgroundColor:'rgba(0,0,0,0.5)',  position: 'absolute', bottom: 0, width:1 }}>
            E-Resources
            </Typography>
        </Box>

      <Grid display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'}>
  
          {/* ***********************Table********************** */}
          <Box  width={'fit-content'}  mt={'2%'} >
              <TableContainer component={Paper} sx={{width:'fit-content'}}>
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <TableHead>
                      <TableRow>
                          <TableCell sx={{fontWeight:'bold',fontSize:'1rem'}}>E-JOURNALS</TableCell>
                          <TableCell sx={{fontWeight:'bold',fontSize:'1rem'}}>E-BOOKS</TableCell>
                          <TableCell sx={{fontWeight:'bold',fontSize:'1rem'}}>RESOURCE SEARCH PLATFORM</TableCell>
  
                      </TableRow>
                      </TableHead>
                      <TableBody >
                      <TableCell sx={{verticalAlign:'top'}}>
                                              {/* 1st row */}
                        {row1.map((row) => (
                            <TableRow
                            key={row.name}
                            >
                           <TableCell sx={{display:'flex', justifyContent:'space-between', alignItems:'center'}} >
  
                              <Button variant='solid' component={Link} to={row.link}
                              >{row.name}</Button>
                            </TableCell>
                            <TableCell ></TableCell>
                            </TableRow>
                        ))}
                      </TableCell>
  
                      <TableCell sx={{verticalAlign:'top'}}>
                                                {/* 2nd row */}
                        {row2.map((row) => (
                            <TableRow
                            key={row.name}
                            >
                           <TableCell sx={{display:'flex',  justifyContent:'space-between', alignItems:'center'}} >
  
                              <Button  variant='solid'component={Link} to={row.link}
                              >{row.name}</Button>
                            </TableCell>
                            <TableCell ></TableCell>
                            </TableRow>
                        ))}
                      </TableCell>
  
  
                      <TableCell  sx={{verticalAlign:'top'}}>
                                                {/* 3rd row */}
                        {row3.map((row) => (
                            <TableRow
                            key={row.name}
                            >
                           <TableCell sx={{display:'flex',  justifyContent:'space-between', alignItems:'center'}} >
  
                              <Button variant='solid' component={Link} to={row.link}
                              >{row.name}</Button>
                            </TableCell>
                            <TableCell ></TableCell>
                            </TableRow>
                        ))}
                      </TableCell>
  
                      </TableBody>
                  </Table>
              </TableContainer>
          </Box>
  
  
        {/* ********************Section 2******************** */}
       
            <Grid display={'flex'} justifyContent={'space-around'} width={1} >
              <Link to={'https://home.quiklrn.com/englishlab/'}>
                <Box marginY={4} p={4} component={Paper} elevation={5} width={'fit-content'} >
                    <Grid display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'}>
                      <Typography variant='h5' textAlign={'left'}>
                              Language Lab
                      </Typography>
                      <Link to={'https://home.quiklrn.com/englishlab/'} >
                      <Typography variant='body1' textAlign={'left'}>
                        Quicklrn Language Communication Lab
                      </Typography>
                      </Link>
                    </Grid>
                </Box>
              </Link>
              <Link to={'https://blended-learning.ieee.org/Portal/Organization/IP/VTU035'}>
                <Box marginY={4} p={4} component={Paper} elevation={5}  >
                    <Grid display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'}>
                        <Typography variant='h5' textAlign={'left'}>
                            IEEE Blended
                        </Typography>
                        <Link to={'https://blended-learning.ieee.org/Portal/Organization/IP/VTU035'} >
                        <Typography variant='body1' textAlign={'left'}>
                        E-Learning Platform
                        </Typography>
                        </Link>
                    </Grid>
                </Box>
              </Link>
            </Grid>
          
</Grid>


        <Footer/>
    </div>
  )
}
